/**
 * Wire-protocol error codes shared between the auth-gated API routes
 * and any client that wants to discriminate them.
 *
 * Lives in its own module (no side effects, no server-only imports)
 * so client bundles can import the constant without dragging Node-
 * only deps from `lib/auth.ts` (privy server SDK, ioredis, envio
 * transport, etc.) into the browser.
 *
 * Keep this file dependency-free.
 */

/**
 * Returned (alongside a human-readable message) by
 * `getAuthenticatedAddress` in `lib/auth.ts` when the caller sent an
 * "active wallet" hint (`X-Viewer-Address` header or `body.address`)
 * that isn't part of their Privy session's linked-wallet set.
 *
 * The chat client matches on this code to auto-trigger a SIWE link
 * (`wallet.loginOrLink()`) for the wagmi-active wallet, instead of
 * misreading the 403 as "no seat" and showing the standard gate.
 */
export const WALLET_NOT_LINKED_CODE = 'wallet_not_linked';
